export const FIREBASE_CUSTOM_TOKEN = 'firebase-custom-token'
